module.exports = __webpack_public_path__ + "static/media/avatar_dragon.6427645d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_dragon.png
// module id = 376
// module chunks = 0